import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { botkeeperDecisions } from '../../data/botkeeper';

/** The four design bets as a 2×2 grid; the first one is featured in deep teal. */
export function DecisionGrid() {
  return <ol className="grid gap-px overflow-hidden rounded-2xl border border-line bg-line md:grid-cols-2" data-id="element-69" data-mp="j0vsyv5lpbhp">
      {botkeeperDecisions.map((d, i) => {
      const featured = i === 0;
      return <li key={d.title} className={`flex flex-col p-6 md:p-8 ${featured ? 'bg-ink-deep' : 'bg-raised'}`} data-id="element-70" data-mp="3mhm41og1ieq9" data-mpi={i}>
            <Reveal delay={i * 0.04} className="flex h-full flex-col" data-id="element-71" data-mp="50uhklrpmlnz">
              <p className={`text-xs font-medium tabular-nums ${featured ? 'text-white/60' : 'text-rust'}`} data-id="element-72" data-mp="53747c8exk7d">
                Decision {String(i + 1).padStart(2, '0')}
              </p>
              <h3 className={`mt-3 text-lg font-semibold leading-snug ${featured ? 'text-white' : 'text-fg'}`} data-id="element-73" data-mp="38ocyjyv7qdd0">
                {d.title}
              </h3>
              <p className={`mt-3 text-sm leading-relaxed ${featured ? 'text-white/80' : 'text-fg-muted'}`} data-id="element-74" data-mp="4ia3jf4cbpi5">{d.body}</p>
              <p className="mt-auto flex flex-wrap items-center gap-2 pt-6 text-xs font-medium" data-id="element-75" data-mp="9fa8tntd8o87">
                <span className={`rounded-full border px-2.5 py-1 line-through decoration-1 ${featured ? 'border-white/25 text-white/60' : 'border-line text-fg-faint'}`} data-id="element-76" data-mp="e8l7h1o0xyp1">
                  {d.before}
                </span>
                <ArrowRightIcon className={`h-3.5 w-3.5 ${featured ? 'text-white/60' : 'text-fg-faint'}`} aria-hidden data-id="element-77" data-mp="3mnwirudptlm1" />
                <span className={`rounded-full px-2.5 py-1 ${featured ? 'bg-white text-ink-deep' : 'bg-ink-soft text-ink'}`} data-id="element-78" data-mp="3qndo8nt56ir7">
                  {d.after}
                </span>
              </p>
            </Reveal>
          </li>;
    })}
    </ol>;
}